export const shouldIncludePerDiem = (source?: any): boolean =>
  source?.includePerDiem !== false;

export const shouldIncludeMiscFees = (source?: any): boolean =>
  Boolean(source?.includeMiscFees);

export const toQuoteNumber = (value: any): number => {
  const parsed = Number(value ?? 0);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const calculateShiftTotal = (
  shift: any,
  includePerDiem: boolean,
  includeMiscFees: boolean
): number => {
  if (shift?.manualCalculation && Number.isFinite(shift?.manualTotal)) return shift.manualTotal;
  const rate = toQuoteNumber(shift?.rate);
  const registerHours = toQuoteNumber(shift?.registerHours);
  const overTimeHours = toQuoteNumber(shift?.overTimeHours);
  const doubleTimeHours = toQuoteNumber(shift?.DoubleTimeHours);
  const perDiem = includePerDiem ? toQuoteNumber(shift?.addOns) : 0;
  const miscFees = includeMiscFees ? toQuoteNumber(shift?.miscFees) : 0;
  const quantity = ['', 0, '0'].includes(shift?.quantity) ? 0 : toQuoteNumber(shift?.quantity) || 1;

  // Match the policy engine: round each worker's rate tier before crew quantity.
  const rateCents = Math.round(rate * 100);
  const hourlyLaborCents =
    Math.round(rateCents * registerHours) +
    Math.round(rateCents * (shift?.manualOvertimeFactor ?? 1.5) * overTimeHours) +
    Math.round(rateCents * (shift?.manualDoubleTimeFactor ?? 2) * doubleTimeHours);
  const labor = Number.isFinite(shift?.agreementLaborTotal)
    ? shift.agreementLaborTotal
    : hourlyLaborCents / 100;
  return (labor + perDiem + miscFees) * quantity;
};

export const normalizeShiftTotal = (
  shift: any,
  includePerDiem: boolean,
  includeMiscFees: boolean
): any => {
  const totals = shift.clientRatePending ? null : calculateShiftTotal(shift, includePerDiem, includeMiscFees);
  return {
    ...shift,
    miscFees: toQuoteNumber(shift?.miscFees),
    totals,
    total: totals
  };
};

export const quoteTableColumnCount = (
  includePerDiem: boolean,
  includeMiscFees: boolean
): number => 13 + (includePerDiem ? 1 : 0) + (includeMiscFees ? 1 : 0);
